module.exports = __webpack_public_path__ + "static/media/VeritoneLogo.5055e52c.svg";